import React, {useState} from "react";
import {Tabs} from "antd";
import styled from "styled-components";
import {ActiveTerminalsTab} from "./ActiveTerminalsTab/ActiveTerminalsTab";
import {CourierTerminalHistoryTab} from "./CourierTerminalHistoryTab/CourierTerminalHistoryTab";
import {TerminalHistoryTab} from "./TerminalHistoryTab/TerminalHistoryTab";

export const TabsContainer = styled(Tabs)`
    @media (max-width: 768px) {
        .ant-tabs-nav {
            display: flex;
            flex-direction: column;
        }
        .ant-tabs-nav-list {
            flex-direction: column;
        }
    }
`;

export const CourierTerminalListPage = () => {
    const [activeTab, setActiveTab] = useState("1");

    return (
        <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
            <Tabs.TabPane tab="Aktif Terminaller" key="1">
                <ActiveTerminalsTab isTabOpened={activeTab === "1"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Terminal Geçmişi" key="2">
                <TerminalHistoryTab isTabOpened={activeTab === "2"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Kurye Geçmişi" key="3">
                <CourierTerminalHistoryTab isTabOpened={activeTab === "3"} />
            </Tabs.TabPane>
        </TabsContainer>
    );
};
